import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import AdminSidebar from "./AdminSidebar";
import { jwtDecode } from "jwt-decode"; // ✅ CORRECT
import "./Admin.css";

const AdminLayout = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            try {
                const decoded = jwtDecode(token);
                const currentTime = Date.now() / 1000; // in seconds

                if (decoded.exp < currentTime) {
                    // Session expired
                    localStorage.removeItem("token");
                    localStorage.removeItem("isAdmin");
                    navigate("/admin/login");
                }
            } catch (err) {
                console.error("Token decode error:", err);
                localStorage.clear();
                navigate("/admin/login");
            }
        }
    }, []);

    return (
        <div className="admin-dashboard">
            <AdminSidebar />
            <div className="admin-content">
                <Outlet />
            </div>
        </div>
    );
};

export default AdminLayout;
